import { Button, Placeholder } from '@/shared/ui/primitives';
import type { FC } from 'react';
import { Plus } from 'lucide-react';

import { TEST_IDS } from '@/testIds';
import styles from './PassesEmptyState.module.css';

interface PassesEmptyStateProps {
  onAddPass: () => void;
  disabled?: boolean;
}

export const PassesEmptyState: FC<PassesEmptyStateProps> = ({ onAddPass, disabled }) => (
  <Placeholder
    className={styles.dashedCard}
    data-testid={TEST_IDS.passesEmptyState}
    title="No passes yet"
    description="Add the first pass to start tracking visits."
    action={
      <Button
        size="md"
        variant="primary"
        onClick={onAddPass}
        disabled={disabled}
        leading={<Plus size={14} aria-hidden="true" />}
        data-testid={TEST_IDS.addPassButton}
      >
        Add first pass
      </Button>
    }
  ></Placeholder>
);
